import axios from 'axios';

export class Axios {

    static basic_auth;

    constructor () {
        this.basic_auth = btoa(`${process.env.REACT_APP_API_USERNAME}:${process.env.REACT_APP_API_PASSWORD}`);
    };

    async get(url) {
        return await axios.get(`${process.env.REACT_APP_API_URL}${url}`, {
            headers: {
                "Authorization": `Basic ${this.basic_auth}`,
                 "ngrok-skip-browser-warning": "true"
            },
        });
    }

    async post(url, body) {
        return await axios.post(`${process.env.REACT_APP_API_URL}${url}`, body, {
            headers: {
                "Authorization": `Basic ${this.basic_auth}`,
                'Content-Type': 'application/json',
                 "ngrok-skip-browser-warning": "true"
            },
        });
    }

    async upload(url, body) {
        return await axios.post(`${process.env.REACT_APP_API_URL}${url}`, body, {
            headers: {
                "Authorization": `Basic ${this.basic_auth}`,
                'Content-Type': 'multipart/form-data',
                "ngrok-skip-browser-warning": "true"
            },
        });
    }

    async login(url, body) {
        return await axios.post(`${process.env.REACT_APP_API_URL}${url}`, body);
    }
}